import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { useCompanies } from '@/hooks/use-companies'
import { listWeedDiagnoses } from '@/services/list-weed-diagnosis'

export interface UseGetWedDiagnosesParams {
  pageLimit: number
  orderBy: string | null
  lastItem: string | null
  searchType: string | null
  search: string | null
}

export const GET_WEED_DIAGNOSES_QUERY = 'diagnoses'

export type UseGetWeedDiagnosesData = NonNullable<
  ReturnType<typeof useGetWeedDiagnoses>['data']
>

export type UseGetWeedDiagnosesResult =
  UseGetWeedDiagnosesData['results'][number]

export function useGetWeedDiagnoses({
  pageLimit,
  orderBy,
  lastItem,
  search,
  searchType,
}: UseGetWedDiagnosesParams) {
  const { selectedCompany } = useCompanies()

  const query = useQuery({
    queryKey: [
      GET_WEED_DIAGNOSES_QUERY,
      selectedCompany?.id,
      { pageLimit, orderBy, lastItem, search, searchType },
    ],
    queryFn: async ({ signal }) => {
      const { results, ...rest } = await listWeedDiagnoses(
        {
          idCompany: selectedCompany.id,
          lastItem,
          pageLimit,
          orderBy,
          search,
          searchType,
        },
        signal,
      )

      return {
        ...rest,
        results: results.map((diagnosis) => {
          const flightDateLabel = new Date(
            `${diagnosis.mosaic.date}T00:00`,
          ).toLocaleDateString('pt-BR')
          const registrationDateLabel = new Date(
            diagnosis.registration_date,
          ).toLocaleDateString('pt-BR')
          const concludedAtLabel = new Date(
            diagnosis.concluded_at,
          ).toLocaleDateString('pt-BR')

          return {
            id: diagnosis.id,
            imageName: diagnosis.mosaic.filename,
            imageType: diagnosis.mosaic.image_type, //tipo da imagem
            demandName: diagnosis.demand_name,
            //regionId: diagnosis.project.region_id, //região do projeto
            culture: diagnosis.culture,
            treatment: diagnosis.treatment,
            idUser: diagnosis.user.id,
            flightDate: diagnosis.mosaic.date,
            flightDateLabel,
            registrationDate: diagnosis.registration_date,
            registrationDateLabel,
            concludedAt: diagnosis.concluded_at,
            concludedAtLabel,
            status: diagnosis.status,
            project: diagnosis.project,
            gsd: diagnosis.mosaic.gsd,
            datum: diagnosis.mosaic.datum,
            companyId: diagnosis.company.id,
          }
        }),
      }
    },
    onError: (err: any) => {
      toast.error('Ocorreu um erro ao buscar os diagnósticos: ' + err.message)
    },
    keepPreviousData: true,
  })

  return query
}
